import {
  Box,
  ColorProps,
  ComponentMultiStyleConfig,
  Icon,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { MdInfo } from "react-icons/md";
import { IconType } from "react-icons";

export type CMMessageInfoProps = {
  size?: "sm" | "md";
  icon?: IconType;
  iconColor?: ColorProps["color"];
  label: string;
} & ComponentStyleProps;

/**
 * 情報メッセージコンポーネント.
 */
export const CMMessageInfo = ({
  size = "md",
  icon = MdInfo,
  iconColor = "blue.500",
  label,

  sx,
  ...rest
}: CMMessageInfoProps) => {
  const styles = useMultiStyleConfig("CMMessageInfoStyles", { size });

  return (
    <Box {...rest} sx={{ ...styles.container, ...sx }}>
      <Icon as={icon} color={iconColor} sx={styles.icon} />
      <Text sx={styles.label}>{label}</Text>
    </Box>
  );
};

export const CMMessageInfoStyles: ComponentMultiStyleConfig = {
  parts: ["container", "icon", "label"],
  baseStyle: {
    container: {
      display: "flex",
      alignItems: "flex-start",
    },
    icon: { w: "20px", h: "20px", mt: "1px" },
    label: {
      ml: "8px",
      fontSize: "md",
    },
  },
  sizes: {
    sm: {
      icon: { w: "18px", h: "18px", mt: "2px" },
      label: {
        ml: "6px",
        fontSize: "sm",
      },
    },
    md: {
      icon: { w: "20px", h: "20px", mt: "1px" },
      label: {
        ml: "8px",
        fontSize: "md",
      },
    },
  },
};
